// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel';

export type MetadataDataTypeEnum = 'INT' | 'STRING' | 'DATE' | 'DOUBLE';

export const PjpAggregationTypeEnum = Object.freeze({
    Sum: 'SUM',
    Avg: 'AVG',
    Count: 'COUNT',
    Max: 'MAX',
    Min: 'MIN'
});
export type PjpAggregationTypeEnumType = $Values<typeof PjpAggregationTypeEnum>;

export type PjpInsightsMetadataModelType = {
    metric: string,
    dataType: MetadataDataTypeEnum,
    label: string,
    groupBy: Array<PjpMetadataGroupByModelType>,
    aggregation: Array<PjpAggregationTypeEnumType>,
    availableFrom: string,
    metricUnit: MetricUnitEnum,
    metricUnitType: PjpMetricUnitTypeEnum,
    metricUnitLabel: string,
    metricPerformanceType: MetricPerformanceType
};

export type PjpMetricUnitTypeEnum =
    | 'DISTANCE'
    | 'TASK'
    | 'PLAN'
    | 'TOUR'
    | 'TEAM'
    | 'CHANNEL'
    | 'WEEKDAY'
    | 'RIDER'
    | 'BEAT';

export type MetricPerformanceType = 'INCREASING' | 'DECREASING';

export type MetricUnitEnum = 'METERS' | 'SECOND' | 'PERCENTAGE' | 'COUNT';

export type PjpMetadataGroupByModelType = {
    groupBy: string,
    dataType: string,
    label: string,
    staticValues: Array<PjpMetadataGroupByValuesModelType>
};

export type PjpMetadataGroupByValuesModelType = {
    groupByValue: string,
    label: string,
    color: string
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PjpInsightsMetadata extends ImmutableModel {
    static fromJS(json: PjpInsightsMetadataModelType): PjpInsightsMetadata {
        const state: Object = Object.assign({}, json);
        state.groupBy = Immutable.List(state.groupBy).map(item =>
            PjpMetadataGroupBy.fromJS(item)
        );
        state.aggregation = Immutable.List(state.aggregation);
        return new this(Immutable.Map(state));
    }

    toJS(): PjpInsightsMetadataModelType {
        return {
            metric: this.metric,
            dataType: this.dataType,
            label: this.label,
            groupBy: this.groupBy.toArray().map(item => item.toJS()),
            aggregation: this.aggregation.toArray(),
            availableFrom: this.availableFrom,
            metricUnit: this.metricUnit,
            metricUnitType: this.metricUnitType,
            metricUnitLabel: this.metricUnitLabel,
            metricPerformanceType: this.metricPerformanceType
        };
    }

    get metric(): string {
        return this._state.get('metric');
    }

    setMetric(metric: string): this {
        return this.clone(this._state.set('metric', metric));
    }

    get dataType(): MetadataDataTypeEnum {
        return this._state.get('dataType');
    }

    setDataType(dataType: MetadataDataTypeEnum): this {
        return this.clone(this._state.set('dataType', dataType));
    }

    get label(): string {
        return this._state.get('label');
    }

    setLabel(label: string): this {
        return this.clone(this._state.set('label', label));
    }

    get groupBy(): Immutable.List<PjpMetadataGroupBy> {
        return this._state.get('groupBy');
    }

    setGroupBy(groupBy: Immutable.List<PjpMetadataGroupBy>): this {
        return this.clone(this._state.set('groupBy', groupBy));
    }

    get aggregation(): Immutable.List<PjpAggregationTypeEnumType> {
        return this._state.get('aggregation');
    }

    setAggregation(
        aggregation: Immutable.List<PjpAggregationTypeEnumType>
    ): this {
        return this.clone(this._state.set('aggregation', aggregation));
    }

    get availableFrom(): string {
        return this._state.get('availableFrom');
    }

    setAvailableFrom(availableFrom: string): this {
        return this.clone(this._state.set('availableFrom', availableFrom));
    }

    get metricUnit(): MetricUnitEnum {
        return this._state.get('metricUnit');
    }

    setMetricUnit(metricUnit: MetricUnitEnum): this {
        return this.clone(this._state.set('metricUnit', metricUnit));
    }

    get metricUnitType(): PjpMetricUnitTypeEnum {
        return this._state.get('metricUnitType');
    }

    setMetricUnitType(metricUnitType: PjpMetricUnitTypeEnum): this {
        return this.clone(this._state.set('metricUnitType', metricUnitType));
    }

    get metricUnitLabel(): string {
        return this._state.get('metricUnitLabel');
    }

    setMetricUnitLabel(metricUnitLabel: string): this {
        return this.clone(this._state.set('metricUnitLabel', metricUnitLabel));
    }

    get metricPerformanceType(): MetricPerformanceType {
        return this._state.get('metricPerformanceType');
    }

    setMetricPerformanceType(
        metricPerformanceType: MetricPerformanceType
    ): this {
        return this.clone(
            this._state.set('metricPerformanceType', metricPerformanceType)
        );
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PjpMetadataGroupBy extends ImmutableModel {
    static fromJS(json: PjpMetadataGroupByModelType): PjpMetadataGroupBy {
        const state: Object = Object.assign({}, json);
        state.staticValues = Immutable.List(state.staticValues).map(item =>
            PjpMetadataGroupByValues.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): PjpMetadataGroupByModelType {
        return {
            groupBy: this.groupBy,
            dataType: this.dataType,
            label: this.label,
            staticValues: this.staticValues.toArray().map(item => item.toJS())
        };
    }

    get groupBy(): string {
        return this._state.get('groupBy');
    }

    setGroupBy(groupBy: string): this {
        return this.clone(this._state.set('groupBy', groupBy));
    }

    get dataType(): string {
        return this._state.get('dataType');
    }

    setDataType(dataType: string): this {
        return this.clone(this._state.set('dataType', dataType));
    }

    get label(): string {
        return this._state.get('label');
    }

    setLabel(label: string): this {
        return this.clone(this._state.set('label', label));
    }

    get staticValues(): Immutable.List<PjpMetadataGroupByValues> {
        return this._state.get('staticValues');
    }

    setStaticValues(
        staticValues: Immutable.List<PjpMetadataGroupByValues>
    ): this {
        return this.clone(this._state.set('staticValues', staticValues));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PjpMetadataGroupByValues extends ImmutableModel {
    static fromJS(
        json: PjpMetadataGroupByValuesModelType
    ): PjpMetadataGroupByValues {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): PjpMetadataGroupByValuesModelType {
        return {
            groupByValue: this.groupByValue,
            label: this.label,
            color: this.color
        };
    }

    get groupByValue(): string {
        return this._state.get('groupByValue');
    }

    setGroupByValue(groupByValue: string): this {
        return this.clone(this._state.set('groupByValue', groupByValue));
    }

    get label(): string {
        return this._state.get('label');
    }

    setLabel(label: string): this {
        return this.clone(this._state.set('label', label));
    }

    get color(): string {
        return this._state.get('color');
    }

    setColor(color: string): this {
        return this.clone(this._state.set('color', color));
    }
}
